import { Injectable } from '@angular/core';
import {
  Router, Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { RootStoreState } from '@app/root-store';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import * as projectTypeActions from '@app/root-store/project-type-store/actions';
import { GetProjectsAction } from './root-store/shared-store/project-store/actions';

@Injectable({
  providedIn: 'root'
})
export class ProjectsResolver implements Resolve<boolean> {
  constructor(private store: Store<RootStoreState.State>) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | any {
    this.store.dispatch(projectTypeActions.GetProjectTypesAction());
    this.store.dispatch(GetProjectsAction());
  }
}
